// Welle 4 — Imports module (last runs, 24h health).
import React from "react";
import { useTranslation } from "react-i18next";
import { Download } from "lucide-react";
import { Link } from "react-router-dom";
import { SectionCard, Pill, formatDateTime } from "./AdminV2Kit";

export default function ImportsCard({ data, developer = false }) {
  const { t } = useTranslation("admin");
  if (!data?.ok) return null;
  const runs = data.last_runs || [];
  return (
    <SectionCard
      title={t("modules.imports.title")}
      icon={Download}
      status={data.failed_24h > 0 ? "critical" : "healthy"}
      testid="adminv2-imports-card"
      actions={
        <div className="flex items-center gap-1.5">
          <Pill tone="zinc">{data.runs_24h} {t("modules.imports.runs24h")}</Pill>
          {data.failed_24h > 0 && (
            <Pill tone="rose">{data.failed_24h} {t("modules.imports.failed24h")}</Pill>
          )}
        </div>
      }
    >
      <ul className="space-y-1.5">
        {runs.slice(0, developer ? 5 : 3).map((r) => {
          const c = r.counts || {};
          return (
            <li
              key={r.ulid}
              data-testid={`adminv2-import-run-${r.ulid}`}
              className="flex items-center justify-between gap-3 rounded-xl border border-zinc-800 bg-zinc-950/50 px-3.5 py-2"
            >
              <div className="min-w-0">
                <Link
                  to={`/admin/imports/${r.ulid}`}
                  className="text-sm text-zinc-200 hover:text-amber-300 transition-colors"
                >
                  {r.source_platform || "—"} · {r.vertical}
                  {r.country ? ` · ${r.country}` : ""}
                </Link>
                <div className="text-[11px] text-zinc-500">
                  {formatDateTime(r.started_at)}
                  {" · "}
                  {c.listings_created ?? 0} {t("modules.imports.created")}
                  {", "}
                  {c.listings_updated ?? 0} {t("modules.imports.updated")}
                  {developer ? `, ${c.received ?? 0} ${t("modules.imports.received")}` : ""}
                </div>
              </div>
              <Pill tone={r.status === "completed" ? "emerald" : r.status === "failed" ? "rose" : "amber"}>
                {r.status}
              </Pill>
            </li>
          );
        })}
      </ul>
    </SectionCard>
  );
}
